<div class="" *ngIf="organisationTypeId == 1 || organisationTypeId == 3">
  <p-panel styleClass="panel-shadow" header="Driver Messages" [style]="{ height: '100%' }">
    <ng-template #noMessages>
      <div class="text-center py-3" style="font-weight: 500; color: #999">No messages</div>
    </ng-template>
    <div
      *ngIf="selectedTask?.driverMessages?.length > 0; else noMessages"
      #messageScroller
      style="max-height: 300px; overflow-y: auto; padding-right: 10px"
    >
      <div
        class="messages message-card"
        [class.is-driver]="driverMessage.userId == selectedTask.driverUserId"
        *ngFor="let driverMessage of selectedTask.driverMessages; let i = index"
        [class.message-even]="i % 2 == 0"
        [class.message-odd]="i % 2 == 1"
      >
        <div class="flex">
          <div class="flex-grow-1 user-name">
            <div
              style="overflow-x: hidden; max-width: 300px; text-overflow: ellipsis"
              title="{{ driverMessage.userName }}"
            >
              {{ driverMessage.userName }}
            </div>
          </div>
          <div class="flex-shrink-1 time-created white-space-nowrap">
            {{ driverMessage.created | datelocal : "ddd DD MMM 'YY HH:mm" }}
          </div>
        </div>
        <div class="message-content">
          {{ driverMessage.messageText }}
        </div>
      </div>
      <div id="scroll-anchor" #scrollAnchor></div>
    </div>
    <div
      *ngIf="selectedTask?.driverId"
      class="driver-message-container"
      style="height: 100%; position: relative; min-height: 50px"
    >
      <div class="flex style2023 pt-1">
        <div class="input-group flex-grow-1">
          <div class="input-group-item">
            <input [(ngModel)]="smsMessage" pInputText placeholder="Type a Message.." />
          </div>
        </div>
        <div>
          <button
            type="button"
            (click)="sendMessageToDriver()"
            pButton
            style="height: 37px"
            label="Send"
            *ngIf="selectedTask?.driverId"
            [disabled]="
              selectedTask.isJobCompleted || smsMessage?.trim().length == 0 || isSendMessageToDriver
            "
            class="ui-button"
          ></button>
        </div>
      </div>
    </div>
    <div
      class=""
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isReloadDriverMessages"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </p-panel>
</div>

<!--

<p-dialog
    header="New Message"
    [(visible)]="isSendMessageToDriver"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '350px' }"
>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
          <textarea
              pInputTextarea
              [(ngModel)]="smsMessage"
              [rows]="3"
              [cols]="35"
              [maxlength]="250"
          ></textarea>
    </div>
    <div style="width: 100%; height: 40px">
      <button
          type="button"
          (click)="closeSendMessageToDriver()"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
          class="ui-button btn-to-right"
      ></button>
      <button
          type="button"
          pButton
          icon="fa ui-icon-check"
          label="Send"
          class="ui-button green-btn btn-to-right"
          (click)="sendMessageToDriver()"
          [disabled]="smsMessage?.trim().length == 0"
      ></button>
    </div>
    <div
        style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: gray;
            opacity: 0.3;
          "
        *ngIf="isBusySendMessageToDriver"
    >
      <img src="assets/images/loader.gif" style="margin-left: 45%; margin-top: 10%" width="50" height="50" alt="load"/>
    </div>
  </div>
</p-dialog>

-->
